<template>
  <div class="bgp-hijacking" :class="{ mobile: isMobile }">
    <p>
      BGP hijacking occurs when a BGP speaker originates address space it is not
      authorised to route. This can be a simple misconfiguration, a typo in
      specifying a block of addresses or a prefix length, so that an
      announcement is made which conflicts with somebody else's addresses. Or it
      can be intentional, to subvert routing for financial, malicious or other
      reasons. Sometimes, route leaks can be turned into re-origination and
      hijacking, through automated systems.
    </p>
    <p>
      For more information on BGP hijacking see the following sources of
      information:
    </p>
    <ul>
      <li>
        <a
          href="https://www.cloudflare.com/learning/security/glossary/bgp-hijacking/"
          target="_blank"
        >
          What is BGP hijacking?
          <fa icon="external-link-alt"></fa>
        </a>
        <span>
          (CloudFlare)
        </span>
      </li>
      <li>
        <a
          href="https://www.thousandeyes.com/learning/glossary/bgp-route-hijacking"
          target="_blank"
        >
          What is BGP route hijacking?
          <fa icon="external-link-alt"></fa>
        </a>
        <span>
          (Thousand Eyes)
        </span>
      </li>
      <li>
        <a
          href="https://www.netscout.com/what-is-ddos/bgp-hijacking"
          target="_blank"
        >
          What is a BGP hijacking?
          <fa icon="external-link-alt"></fa>
        </a>
        <span>
          (NetScout)
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'LearnMoreAboutBGP',
  computed: {
    ...mapGetters(['isMobile'])
  }
};
</script>

<style lang="scss" scoped>
.bgp-hijacking {
  padding-top: 1rem;
  transition: all 2s;

  p {
    line-height: 1.5;
  }

  ul {
    list-style-type: none;

    li {
      margin: 0.25rem 0;

      a {
        color: $text-light-blue;

        &:hover {
          color: $text-light-blue;
        }
      }

      span {
        padding-left: 0.5rem;
      }
    }
  }
}

.mobile.bgp-hijacking {
  li > span {
    display: block;
    padding-left: 0;
  }
}
</style>
